import api from "../../infra/api";

class ServanexosConsultaAcesso {
    async listarAnexos(codigoConsultaAcessoAnalise) {
        let url = `/api/v1/ConsultaDeAcessoAnaliseVincDocs?page=1&start=0&limit=999&fields=["NomeArquivo","ExtensaoArquivo","CodigoConsultaAcessoAnalise","Id","CodigoDocumento","ConsultaDeAcessoAnalise"]&filter=[{"property":"CodigoConsultaAcessoAnalise","value":${codigoConsultaAcessoAnalise},"and":true,"not":false}]`;

        const response = await api({
            method: "GET",
            url: url
        });
        
        return response.data;
    }

    async downloadAnexo(dto) {
        let url = `/api/v1/ConsultaDeAcessoAnaliseVincDocs/RealizarDownloadDocumentoConsultaDeAcessoAnalise`;	

        const response = await api({
            method: "POST",
            url,
            data: JSON.stringify(dto)
        });

        return response.data;
    }
}

export default new ServanexosConsultaAcesso();